export default __webpack_public_path__ + "static/media/Synergist_Emblem_Outline_black.a942d9ce.svg";